export function insertPaybillMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      insertPaybillId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateInsertPaybillId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyInsertPaybills(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateInsertPaybillId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function insertPaybillMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, insertPaybillId: json.result.objectId},
  };
}